import type { LoadMessages } from '@twisto/base/i18n-provider'
import { loadNamedCatalogs } from '@twisto/base/i18n-provider'
import { products } from '@twisto/environment/locale-catalogs'

export const loadMessages: LoadMessages = (language) =>
  loadNamedCatalogs(products.b2c.flow, {
    flow: () =>
      import(
        /* webpackChunkName: "[request]" */ `../../../public/b2c/locale/${language}/flow-messages`
      ),
    common: () =>
      import(
        /* webpackChunkName: "[request]" */ `../../../public/b2c/locale/${language}/common-messages`
      ),
  })
